<!-- Enhanced Styleguide Demo -->
<div class="styleguide-container">
  <div class="hero-section">
    <div class="hero-content">
      <h1 class="hero-title">System Styleguide</h1>
    </div>
  </div>

  <div class="components-grid">
    <section class="component-section">
      <div class="section-header">
        <div class="section-title-wrapper">
          <h2 class="section-title">V3 Button System</h2>
          <span class="component-count">{{ buttonTypes.length * buttonSizes.length }} variants</span>
        </div>
        <p class="section-description">Comprehensive button system with multiple types and sizes for all use cases</p>
      </div>
      <div class="component-showcase">
        <div class="showcase-item wide" *ngFor="let type of buttonTypes">
          <div class="component-preview button-type-group">
            <h3 class="button-type-label">{{ type }}</h3>
            <div class="button-size-row">
              <ptl-button
                *ngFor="let size of buttonSizes"
                [type]="type"
                [size]="size"
                [disabled]="false"
                [icon]="LucideChevronLeft"
                [iconSuffix]="LucideChevronRight"
                text="Button"
                ariaLabel="Button action"
                class="button-variant"
              ></ptl-button>
            </div>
          </div>
          <div class="component-meta">
            <span class="component-name">{{ type }} ({{ buttonSizes.length }} sizes)</span>
            <button class="copy-btn" mat-icon-button (click)="copyToClipboard('buttonType_' + type)" matTooltip="Copy HTML">
              <mat-icon>content_copy</mat-icon>
            </button>
          </div>
        </div>
      </div>
    </section>

    <section class="component-section typography-section">
      <div class="section-header">
        <div class="section-title-wrapper">
          <h2 class="section-title">Typography</h2>
          <span class="component-count">19 styles</span>
        </div>
        <p class="section-description">DM Sans font family with V3 typography system - body/size-weight format</p>
      </div>
      <div class="typography-table-container">
        <table class="typography-table">
          <thead>
            <tr>
              <th class="preview-cell">Preview</th>
              <th class="class-name-cell">Class Name</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="preview-cell"><h1 class="headline1 bold">The quick brown fox jumps over the lazy dog</h1></td>
              <td class="class-name-cell"><code>headline1 bold</code></td>
              <td>
                <button class="copy-btn" mat-icon-button (click)="copyToClipboard('headline1')" matTooltip="Copy CSS">
                  <mat-icon>content_copy</mat-icon>
                </button>
              </td>
            </tr>
            <tr>
              <td class="preview-cell"><h2 class="headline2">The quick brown fox jumps over the lazy dog</h2></td>
              <td class="class-name-cell"><code>headline2</code></td>
              <td>
                <button class="copy-btn" mat-icon-button (click)="copyToClipboard('headline2')" matTooltip="Copy CSS">
                  <mat-icon>content_copy</mat-icon>
                </button>
              </td>
            </tr>
            <tr>
              <td class="preview-cell"><h3 class="headline3">The quick brown fox jumps over the lazy dog</h3></td>
              <td class="class-name-cell"><code>headline3</code></td>
              <td>
                <button class="copy-btn" mat-icon-button (click)="copyToClipboard('headline3')" matTooltip="Copy CSS">
                  <mat-icon>content_copy</mat-icon>
                </button>
              </td>
            </tr>
            <tr>
              <td class="preview-cell"><h4 class="headline4">The quick brown fox jumps over the lazy dog</h4></td>
              <td class="class-name-cell"><code>headline4</code></td>
              <td>
                <button class="copy-btn" mat-icon-button (click)="copyToClipboard('headline4')" matTooltip="Copy CSS">
                  <mat-icon>content_copy</mat-icon>
                </button>
              </td>
            </tr>
            <tr>
              <td class="preview-cell"><h5 class="headline5">The quick brown fox jumps over the lazy dog</h5></td>
              <td class="class-name-cell"><code>headline5</code></td>
              <td>
                <button class="copy-btn" mat-icon-button (click)="copyToClipboard('headline5')" matTooltip="Copy CSS">
                  <mat-icon>content_copy</mat-icon>
                </button>
              </td>
            </tr>
            <tr>
              <td class="preview-cell"><h6 class="headline6">The quick brown fox jumps over the lazy dog</h6></td>
              <td class="class-name-cell"><code>headline6</code></td>
              <td>
                <button class="copy-btn" mat-icon-button (click)="copyToClipboard('headline6')" matTooltip="Copy CSS">
                  <mat-icon>content_copy</mat-icon>
                </button>
              </td>
            </tr>
            <tr>
              <td class="preview-cell"><p class="caption semibold uppercase">The quick brown fox jumps over the lazy dog</p></td>
              <td class="class-name-cell"><code>caption semibold</code></td>
              <td>
                <button class="copy-btn" mat-icon-button (click)="copyToClipboard('caption-semibold')" matTooltip="Copy CSS">
                  <mat-icon>content_copy</mat-icon>
                </button>
              </td>
            </tr>
            <tr>
              <td class="preview-cell"><p class="caption medium uppercase">The quick brown fox jumps over the lazy dog</p></td>
              <td class="class-name-cell"><code>caption medium</code></td>
              <td>
                <button class="copy-btn" mat-icon-button (click)="copyToClipboard('caption-medium')" matTooltip="Copy CSS">
                  <mat-icon>content_copy</mat-icon>
                </button>
              </td>
            </tr>
            <tr>
              <td class="preview-cell"><p class="body-l link">The quick brown fox jumps over the lazy dog</p></td>
              <td class="class-name-cell"><code>body-l link</code></td>
              <td>
                <button class="copy-btn" mat-icon-button (click)="copyToClipboard('body-l-link')" matTooltip="Copy CSS">
                  <mat-icon>content_copy</mat-icon>
                </button>
              </td>
            </tr>
            <tr>
              <td class="preview-cell"><p class="body-l">The quick brown fox jumps over the lazy dog</p></td>
              <td class="class-name-cell"><code>body-l</code></td>
              <td>
                <button class="copy-btn" mat-icon-button (click)="copyToClipboard('body-l-semibold')" matTooltip="Copy CSS">
                  <mat-icon>content_copy</mat-icon>
                </button>
              </td>
            </tr>
            <tr>
              <td class="preview-cell"><p class="body-l">The quick brown fox jumps over the lazy dog</p></td>
              <td class="class-name-cell"><code>body-l</code></td>
              <td>
                <button class="copy-btn" mat-icon-button (click)="copyToClipboard('body-l-medium')" matTooltip="Copy CSS">
                  <mat-icon>content_copy</mat-icon>
                </button>
              </td>
            </tr>
            <tr>
              <td class="preview-cell"><p class="body-m link">The quick brown fox jumps over the lazy dog</p></td>
              <td class="class-name-cell"><code>body-m link</code></td>
              <td>
                <button class="copy-btn" mat-icon-button (click)="copyToClipboard('body-m-link')" matTooltip="Copy CSS">
                  <mat-icon>content_copy</mat-icon>
                </button>
              </td>
            </tr>
            <tr>
              <td class="preview-cell"><p class="body-m semibold">The quick brown fox jumps over the lazy dog</p></td>
              <td class="class-name-cell"><code>body-m semibold</code></td>
              <td>
                <button class="copy-btn" mat-icon-button (click)="copyToClipboard('body-m-semibold')" matTooltip="Copy CSS">
                  <mat-icon>content_copy</mat-icon>
                </button>
              </td>
            </tr>
            <tr>
              <td class="preview-cell"><p class="body-m">The quick brown fox jumps over the lazy dog</p></td>
              <td class="class-name-cell"><code>body-m</code></td>
              <td>
                <button class="copy-btn" mat-icon-button (click)="copyToClipboard('body-m-medium')" matTooltip="Copy CSS">
                  <mat-icon>content_copy</mat-icon>
                </button>
              </td>
            </tr>
            <tr>
              <td class="preview-cell"><p class="body-s link">The quick brown fox jumps over the lazy dog</p></td>
              <td class="class-name-cell"><code>body-s link</code></td>
              <td>
                <button class="copy-btn" mat-icon-button (click)="copyToClipboard('body-s-link')" matTooltip="Copy CSS">
                  <mat-icon>content_copy</mat-icon>
                </button>
              </td>
            </tr>
            <tr>
              <td class="preview-cell"><p class="body-s bold">The quick brown fox jumps over the lazy dog</p></td>
              <td class="class-name-cell"><code>body-s bold</code></td>
              <td>
                <button class="copy-btn" mat-icon-button (click)="copyToClipboard('body-s-semibold')" matTooltip="Copy CSS">
                  <mat-icon>content_copy</mat-icon>
                </button>
              </td>
            </tr>
            <tr>
              <td class="preview-cell"><p class="body-s medium">The quick brown fox jumps over the lazy dog</p></td>
              <td class="class-name-cell"><code>body-s medium</code></td>
              <td>
                <button class="copy-btn" mat-icon-button (click)="copyToClipboard('body-s-medium')" matTooltip="Copy CSS">
                  <mat-icon>content_copy</mat-icon>
                </button>
              </td>
            </tr>
            <tr>
              <td class="preview-cell"><p class="body-xs link">The quick brown fox jumps over the lazy dog</p></td>
              <td class="class-name-cell"><code>body-xs link</code></td>
              <td>
                <button class="copy-btn" mat-icon-button (click)="copyToClipboard('body-xs-link')" matTooltip="Copy CSS">
                  <mat-icon>content_copy</mat-icon>
                </button>
              </td>
            </tr>
            <tr>
              <td class="preview-cell"><p class="body-xs semibold">The quick brown fox jumps over the lazy dog</p></td>
              <td class="class-name-cell"><code>body-xs semibold</code></td>
              <td>
                <button class="copy-btn" mat-icon-button (click)="copyToClipboard('body-xs-semibold')" matTooltip="Copy CSS">
                  <mat-icon>content_copy</mat-icon>
                </button>
              </td>
            </tr>
            <tr>
              <td class="preview-cell"><p class="body-xs semibold">The quick brown fox jumps over the lazy dog</p></td>
              <td class="class-name-cell"><code>body-xs semibold</code></td>
              <td>
                <button class="copy-btn" mat-icon-button (click)="copyToClipboard('body-xs-medium')" matTooltip="Copy CSS">
                  <mat-icon>content_copy</mat-icon>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>
    <section class="component-section">
      <div class="section-header">
        <div class="section-title-wrapper">
          <h2 class="section-title">Flat Buttons</h2>
        </div>
        <p class="section-description">Primary action buttons with solid background colors</p>
      </div>
      <div class="component-showcase">
        <div class="showcase-item">
          <div class="component-preview">
            <ptl-sg-button type="flat" color="primary" text="Primary" (clicked)="onButtonClick('Primary')"></ptl-sg-button>
          </div>
          <div class="component-meta">
            <span class="component-name">Primary</span>
            <button class="copy-btn" mat-icon-button (click)="copyToClipboard('flatButtonPrimary')" matTooltip="Copy HTML">
              <mat-icon>content_copy</mat-icon>
            </button>
          </div>
        </div>
        <div class="showcase-item">
          <div class="component-preview">
            <ptl-sg-button type="flat" color="accent" text="Accent" (clicked)="onButtonClick('Accent')"></ptl-sg-button>
          </div>
          <div class="component-meta">
            <span class="component-name">Accent</span>
            <button class="copy-btn" mat-icon-button (click)="copyToClipboard('flatButtonAccent')" matTooltip="Copy HTML">
              <mat-icon>content_copy</mat-icon>
            </button>
          </div>
        </div>
        <div class="showcase-item">
          <div class="component-preview">
            <ptl-sg-button type="flat" color="warn" text="Warning" (clicked)="onButtonClick('Warn')"></ptl-sg-button>
          </div>
          <div class="component-meta">
            <span class="component-name">Warning</span>
            <button class="copy-btn" mat-icon-button (click)="copyToClipboard('flatButtonWarn')" matTooltip="Copy HTML">
              <mat-icon>content_copy</mat-icon>
            </button>
          </div>
        </div>
      </div>
    </section>

    <section class="component-section">
      <div class="section-header">
        <div class="section-title-wrapper">
          <h2 class="section-title">Stroked Buttons</h2>
        </div>
        <p class="section-description">Secondary action buttons with outline styles</p>
      </div>
      <div class="component-showcase">
        <div class="showcase-item">
          <div class="component-preview">
            <ptl-sg-button type="stroked" color="primary" text="Primary" (clicked)="onButtonClick('Primary Stroked')"></ptl-sg-button>
          </div>
          <div class="component-meta">
            <span class="component-name">Primary</span>
            <button class="copy-btn" mat-icon-button (click)="copyToClipboard('strokedButtonPrimary')" matTooltip="Copy HTML">
              <mat-icon>content_copy</mat-icon>
            </button>
          </div>
        </div>
        <div class="showcase-item">
          <div class="component-preview">
            <ptl-sg-button type="stroked" color="accent" text="Accent" (clicked)="onButtonClick('Accent Stroked')"></ptl-sg-button>
          </div>
          <div class="component-meta">
            <span class="component-name">Accent</span>
            <button class="copy-btn" mat-icon-button (click)="copyToClipboard('strokedButtonAccent')" matTooltip="Copy HTML">
              <mat-icon>content_copy</mat-icon>
            </button>
          </div>
        </div>
        <div class="showcase-item">
          <div class="component-preview">
            <ptl-sg-button type="stroked" color="warn" text="Warning" (clicked)="onButtonClick('Warn Stroked')"></ptl-sg-button>
          </div>
          <div class="component-meta">
            <span class="component-name">Warning</span>
            <button class="copy-btn" mat-icon-button (click)="copyToClipboard('strokedButtonWarn')" matTooltip="Copy HTML">
              <mat-icon>content_copy</mat-icon>
            </button>
          </div>
        </div>
      </div>
    </section>

    <section class="component-section">
      <div class="section-header">
        <div class="section-title-wrapper">
          <h2 class="section-title">Icon Buttons</h2>
        </div>
        <p class="section-description">Buttons enhanced with meaningful icons for better UX</p>
      </div>
      <div class="component-showcase">
        <div class="showcase-item">
          <div class="component-preview">
            <ptl-sg-button type="flat" color="primary" matIconName="save" text="Save" (clicked)="onButtonClick('Save')"></ptl-sg-button>
          </div>
          <div class="component-meta">
            <span class="component-name">Save Action</span>
            <button class="copy-btn" mat-icon-button (click)="copyToClipboard('flatButtonWithIcon')" matTooltip="Copy HTML">
              <mat-icon>content_copy</mat-icon>
            </button>
          </div>
        </div>
        <div class="showcase-item">
          <div class="component-preview">
            <ptl-sg-button type="stroked" color="accent" matIconName="edit" text="Edit" (clicked)="onButtonClick('Edit')"></ptl-sg-button>
          </div>
          <div class="component-meta">
            <span class="component-name">Edit Action</span>
            <button class="copy-btn" mat-icon-button (click)="copyToClipboard('strokedButtonWithIcon')" matTooltip="Copy HTML">
              <mat-icon>content_copy</mat-icon>
            </button>
          </div>
        </div>
        <div class="showcase-item">
          <div class="component-preview">
            <ptl-sg-button type="flat" color="warn" matIconName="delete" text="Delete" (clicked)="onButtonClick('Delete')"></ptl-sg-button>
          </div>
          <div class="component-meta">
            <span class="component-name">Delete Action</span>
            <button class="copy-btn" mat-icon-button (click)="copyToClipboard('flatButtonDelete')" matTooltip="Copy HTML">
              <mat-icon>content_copy</mat-icon>
            </button>
          </div>
        </div>
      </div>
    </section>

    <section class="component-section">
      <div class="section-header">
        <div class="section-title-wrapper">
          <h2 class="section-title">Icon Only Buttons</h2>
        </div>
        <p class="section-description">Compact icon-only buttons for toolbars and actions</p>
      </div>
      <div class="component-showcase">
        <div class="showcase-item">
          <div class="component-preview">
            <ptl-sg-button type="icon" color="primary" matIconName="edit" (clicked)="onButtonClick('Primary Icon')"></ptl-sg-button>
          </div>
          <div class="component-meta">
            <span class="component-name">Primary</span>
            <button class="copy-btn" mat-icon-button (click)="copyToClipboard('iconButtonPrimary')" matTooltip="Copy HTML">
              <mat-icon>content_copy</mat-icon>
            </button>
          </div>
        </div>
        <div class="showcase-item">
          <div class="component-preview">
            <ptl-sg-button type="icon" color="accent" matIconName="settings" (clicked)="onButtonClick('Accent Icon')"></ptl-sg-button>
          </div>
          <div class="component-meta">
            <span class="component-name">Accent</span>
            <button class="copy-btn" mat-icon-button (click)="copyToClipboard('iconButtonAccent')" matTooltip="Copy HTML">
              <mat-icon>content_copy</mat-icon>
            </button>
          </div>
        </div>
        <div class="showcase-item">
          <div class="component-preview">
            <ptl-sg-button type="icon" color="warn" matIconName="delete" (clicked)="onButtonClick('Warn Icon')"></ptl-sg-button>
          </div>
          <div class="component-meta">
            <span class="component-name">Warning</span>
            <button class="copy-btn" mat-icon-button (click)="copyToClipboard('iconButtonWarn')" matTooltip="Copy HTML">
              <mat-icon>content_copy</mat-icon>
            </button>
          </div>
        </div>
        <div class="showcase-item">
          <div class="component-preview">
            <ptl-sg-button type="icon" matIconName="close" [disabled]="true"></ptl-sg-button>
          </div>
          <div class="component-meta">
            <span class="component-name">Disabled</span>
            <button class="copy-btn" mat-icon-button (click)="copyToClipboard('iconButtonDisabled')" matTooltip="Copy HTML">
              <mat-icon>content_copy</mat-icon>
            </button>
          </div>
        </div>
      </div>
    </section>

    <section class="component-section">
      <div class="section-header">
        <div class="section-title-wrapper">
          <h2 class="section-title">SVG Sprite Icon Buttons</h2>
        </div>
        <p class="section-description">Buttons using custom SVG sprite icons from the project icon library</p>
      </div>
      <div class="component-showcase">
        <div class="showcase-item">
          <div class="component-preview">
            <ptl-sg-button type="flat" color="primary" spriteSvgName="save" text="Save Document" (clicked)="onButtonClick('Save SVG')">
            </ptl-sg-button>
          </div>
          <div class="component-meta">
            <span class="component-name">Save with SVG</span>
            <button class="copy-btn" mat-icon-button (click)="copyToClipboard('flatButtonSvgSave')" matTooltip="Copy HTML">
              <mat-icon>content_copy</mat-icon>
            </button>
          </div>
        </div>
        <div class="showcase-item">
          <div class="component-preview">
            <ptl-sg-button type="stroked" color="accent" spriteSvgName="edit" text="Edit Content" (clicked)="onButtonClick('Edit SVG')">
            </ptl-sg-button>
          </div>
          <div class="component-meta">
            <span class="component-name">Edit with SVG</span>
            <button class="copy-btn" mat-icon-button (click)="copyToClipboard('strokedButtonSvgEdit')" matTooltip="Copy HTML">
              <mat-icon>content_copy</mat-icon>
            </button>
          </div>
        </div>
        <div class="showcase-item">
          <div class="component-preview">
            <ptl-sg-button type="icon" color="primary" spriteSvgName="profile" (clicked)="onButtonClick('Profile SVG')"></ptl-sg-button>
          </div>
          <div class="component-meta">
            <span class="component-name">Profile Icon</span>
            <button class="copy-btn" mat-icon-button (click)="copyToClipboard('iconButtonSvgProfile')" matTooltip="Copy HTML">
              <mat-icon>content_copy</mat-icon>
            </button>
          </div>
        </div>
        <div class="showcase-item">
          <div class="component-preview">
            <ptl-sg-button type="icon" color="accent" spriteSvgName="settings" (clicked)="onButtonClick('Settings SVG')"></ptl-sg-button>
          </div>
          <div class="component-meta">
            <span class="component-name">Settings Icon</span>
            <button class="copy-btn" mat-icon-button (click)="copyToClipboard('iconButtonSvgSettings')" matTooltip="Copy HTML">
              <mat-icon>content_copy</mat-icon>
            </button>
          </div>
        </div>
        <div class="showcase-item">
          <div class="component-preview">
            <ptl-sg-button type="flat" color="warn" spriteSvgName="trash" text="Delete" (clicked)="onButtonClick('Delete SVG')">
            </ptl-sg-button>
          </div>
          <div class="component-meta">
            <span class="component-name">Delete with SVG</span>
            <button class="copy-btn" mat-icon-button (click)="copyToClipboard('flatButtonSvgDelete')" matTooltip="Copy HTML">
              <mat-icon>content_copy</mat-icon>
            </button>
          </div>
        </div>
        <div class="showcase-item">
          <div class="component-preview">
            <ptl-sg-button
              type="stroked"
              color="primary"
              spriteSvgName="download"
              text="Download File"
              (clicked)="onButtonClick('Download SVG')"
            >
            </ptl-sg-button>
          </div>
          <div class="component-meta">
            <span class="component-name">Download Action</span>
            <button class="copy-btn" mat-icon-button (click)="copyToClipboard('strokedButtonSvgDownload')" matTooltip="Copy HTML">
              <mat-icon>content_copy</mat-icon>
            </button>
          </div>
        </div>
      </div>
    </section>

    <section class="component-section">
      <div class="section-header">
        <div class="section-title-wrapper">
          <h2 class="section-title">Form Inputs</h2>
          <span class="component-count">2 variants</span>
        </div>
        <p class="section-description">Styled form inputs with optional icon integration</p>
      </div>
      <div class="component-showcase">
        <div class="showcase-item">
          <div class="component-preview">
            <ptl-sg-input [withIcon]="false" [icon]="LucideSearch" type="text" placeholder="Search content"></ptl-sg-input>
          </div>
          <div class="component-meta">
            <span class="component-name">Basic Input</span>
            <button class="copy-btn" mat-icon-button (click)="copyToClipboard('inputSearchByName')" matTooltip="Copy HTML">
              <mat-icon>content_copy</mat-icon>
            </button>
          </div>
        </div>
        <div class="showcase-item">
          <div class="component-preview">
            <ptl-sg-input [withIcon]="true" [icon]="LucideSearch" type="text" placeholder="Search by name"></ptl-sg-input>
          </div>
          <div class="component-meta">
            <span class="component-name">With Icon</span>
            <button class="copy-btn" mat-icon-button (click)="copyToClipboard('inputWithSearchIcon')" matTooltip="Copy HTML">
              <mat-icon>content_copy</mat-icon>
            </button>
          </div>
        </div>
      </div>
    </section>

    <section class="component-section">
      <div class="section-header">
        <div class="section-title-wrapper">
          <h2 class="section-title">Toggle Switches</h2>
        </div>
        <p class="section-description">Interactive toggle components for boolean settings</p>
      </div>
      <div class="component-showcase">
        <div class="showcase-item">
          <div class="component-preview">
            <ptl-sg-toggle [checked]="toggleEnabled" (toggleChange)="onToggleChange($event)"> Enable tickets</ptl-sg-toggle>
          </div>
          <div class="component-meta">
            <span class="component-name">Enabled</span>
            <button class="copy-btn" mat-icon-button (click)="copyToClipboard('toggleEnabled')" matTooltip="Copy HTML">
              <mat-icon>content_copy</mat-icon>
            </button>
          </div>
        </div>
        <div class="showcase-item">
          <div class="component-preview">
            <ptl-sg-toggle [disabled]="true"> Disabled toggle</ptl-sg-toggle>
          </div>
          <div class="component-meta">
            <span class="component-name">Disabled</span>
            <button class="copy-btn" mat-icon-button (click)="copyToClipboard('toggleDisabled')" matTooltip="Copy HTML">
              <mat-icon>content_copy</mat-icon>
            </button>
          </div>
        </div>
        <div class="showcase-item">
          <div class="component-preview">
            <ptl-sg-toggle [waitingList]="true" size="small" [checked]="false"> Add extra to waiting list</ptl-sg-toggle>
          </div>
          <div class="component-meta">
            <span class="component-name">Small Size</span>
            <button class="copy-btn" mat-icon-button (click)="copyToClipboard('toggleWaitingList')" matTooltip="Copy HTML">
              <mat-icon>content_copy</mat-icon>
            </button>
          </div>
        </div>
      </div>
    </section>

    <section class="component-section">
      <div class="section-header">
        <div class="section-title-wrapper">
          <h2 class="section-title">Radio Groups</h2>
        </div>
        <p class="section-description">Radio button groups for mutually exclusive selections</p>
      </div>
      <div class="component-showcase">
        <div class="showcase-item wide">
          <div class="component-preview">
            <ptl-sg-radio-group
              [options]="radioOptions"
              [(ngModel)]="eventType"
              (selectionChange)="onRadioChange($event)"
              name="eventTypeSelector"
            >
            </ptl-sg-radio-group>
          </div>
          <div class="component-meta">
            <span class="component-name">Event Type Selector</span>
            <button class="copy-btn" mat-icon-button (click)="copyToClipboard('radioGroupEventType')" matTooltip="Copy HTML">
              <mat-icon>content_copy</mat-icon>
            </button>
          </div>
        </div>
      </div>
    </section>

    <section class="component-section icons-section">
      <div class="section-header">
        <div class="section-title-wrapper">
          <h2 class="section-title">SVG Icon Library</h2>
          <span class="component-count">{{ svgIcons.length }} icons</span>
        </div>
        <p class="section-description">Comprehensive icon set optimized for web performance</p>
        <div class="icons-search">
          <mat-form-field appearance="outline">
            <mat-label>Search icons...</mat-label>
            <input matInput [(ngModel)]="iconSearchTerm" placeholder="Type to filter icons" />
            <mat-icon matSuffix>search</mat-icon>
          </mat-form-field>
        </div>
      </div>
      <div class="icons-grid">
        <div class="icon-item" *ngFor="let icon of getFilteredIcons()" [class.icon-item-highlighted]="isIconHighlighted(icon)">
          <div class="icon-preview">
            <svg class="icon-svg">
              <use [ogSvgUnify]="'assets/sprite/sprite.svg#' + icon"></use>
            </svg>
          </div>
          <div class="icon-info">
            <span class="icon-name">{{ icon }}</span>
            <button class="icon-copy-btn" mat-icon-button (click)="copyToClipboard('svgIcon_' + icon)" matTooltip="Copy SVG code">
              <mat-icon>content_copy</mat-icon>
            </button>
          </div>
        </div>
      </div>
      <div class="icons-footer" *ngIf="getFilteredIcons().length === 0">
        <div class="empty-state">
          <mat-icon>search_off</mat-icon>
          <p>No icons found for "{{ iconSearchTerm }}"</p>
        </div>
      </div>
    </section>
  </div>
</div>
